import { FormType } from '@cod-monorepo/interfaces';
import { StepConfig } from '../../../../shared/types/step-config.type';

export const ItemOrQuantityInternationalStepConfig: StepConfig = {
    type: FormType.ITEM_OR_QUANTITY_INTERNATIONAL
};
